export * from "./button-config.view";
